export { default as profilePageViewProps } from './profilePageViewProps';
export { default as profileReviewsPageViewProps } from './profileReviewPageViewProps';
